module.exports = __webpack_public_path__ + "static/LocalGov-907c80a5444fe7a10673907a605e642b.png";